/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { useApiWithTimeout } from "hooks/ApiWrapperWithTimeout";
import { useCallApi } from "hooks/CallApiHook";
import { NotificationApi } from "client";
import { Const } from "const";

export const useNotificationList = (next?: string) => {
  const [notificationApi, cancelNotificationApi] = useApiWithTimeout(
    NotificationApi,
    Const.operationTimeout.getNotificationList
  );

  return useCallApi(
    async () => {
      return notificationApi.getNotificationList({
        cursorKey: next,
        maxCount: Const.notificationPageSize,
      });
    },
    cancelNotificationApi,
    [cancelNotificationApi, next, notificationApi]
  );
};
